<template>
  <v-container fill-height fluid justify="center">
    <v-layout wrap>
      <v-flex xs12 sm10 lg8 offset-sm1 offset-lg2>
        <v-card
          elevation="4"
          light
          tag="section"
          :class="{ 'rounded-xl': rounded }"
        >
          <template v-if="$scopedSlots.title">
            <v-card-title>
              <v-layout align-center justify-center>
                <!-- <h3 class="headline"><slot name="title"></slot></h3> -->
                <slot name="title"></slot>
              </v-layout>
            </v-card-title>
            <template v-if="$scopedSlots.subtitle">
              <v-card-subtitle>
                <v-layout align-center justify-center>
                  <!-- <h5 class="headline"><slot name="subtitle"></slot></h5> -->
                  <slot name="subtitle"></slot>
                </v-layout>
              </v-card-subtitle>
            </template>
            <v-divider></v-divider>
          </template>
          <v-card-text v-if="$scopedSlots.default">
            <v-divider v-if="$scopedSlots.title"></v-divider>
            <slot></slot>
            <v-divider v-if="$scopedSlots.actions"></v-divider>
          </v-card-text>
          <template v-if="$scopedSlots.actions">
            <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
              <v-flex>
                <div align="center">
                  <slot name="actions"></slot>
                </div>
              </v-flex>
            </v-card-actions>
          </template>
        </v-card>
        <v-container v-if="$scopedSlots.append">
          <slot name="append"></slot>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Container",
  props: {
    rounded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
